<div class="op-dialog">

  <div class="op-header">
    <h2 class="op-title op-title--danger">
      <mat-icon>delete_forever</mat-icon>
      Eliminar Operación
    </h2>
    <button mat-icon-button class="close-button" (click)="cancelar()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="op-content">
    <div class="section-header">
      <mat-icon class="small-icon">receipt_long</mat-icon>
      <span>Operación</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">ID</label>
      <span class="field-value">{{ operacion?.isooper }}</span>

      <label class="field-label">Compañía</label>
      <span class="field-value field-value--text">{{ operacion?.nombreCompania }}</span>

      <label class="field-label">Fecha</label>
      <span class="field-value">{{ operacion?.fechaOperacion | smartDate }}</span>

      <label class="field-label">Tipo</label>
      <span class="field-value">
        <span class="entrada-badge"
              [ngClass]="{'bajista': operacion?.tipoOperacion?.includes('↓'), 'alcista': operacion?.tipoOperacion?.includes('↑')}"
              [class.tipo-badge]="!operacion?.tipoOperacion?.includes('↓') && !operacion?.tipoOperacion?.includes('↑')">
          {{ operacion?.tipoOperacion }}
        </span>
      </span>
    </div>

    <ng-container *ngIf="isOpeValid; else noValida">
      <div class="aviso-broker" *ngIf="isBroker">
        <mat-icon>warning</mat-icon>
        <span>Esta acción solo elimina la operación en la base de datos. No se envía ninguna orden al broker; la posición real en el broker no se modifica.</span>
      </div>
      <div class="confirm-msg">¿Seguro que quieres eliminar esta operación? Esta acción no se puede deshacer.</div>
    </ng-container>
    <ng-template #noValida>
      <div class="alert-no-numbers">Solo se pueden eliminar operaciones de Entrada y Salida.</div>
    </ng-template>
  </div>

  <div class="op-actions">
    <ng-container *ngIf="isOpeValid; else soloCerrar">
      <button mat-stroked-button (click)="cancelar()">Cancelar</button>
      <button mat-flat-button color="warn" (click)="eliminar()">Eliminar</button>
    </ng-container>
    <ng-template #soloCerrar>
      <button mat-flat-button color="primary" (click)="cancelar()">Aceptar</button>
    </ng-template>
  </div>

</div>
